// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.00391 10.0041V8.00015H5.00391V8.00406H5V10.0041H7.00391Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 5.58594L6 1.58594L2 5.58594V22.0002L11.5 22V15H18.5V22H22V9.99561H20.9751C20.7275 7.49954 18.6607 5.48522 16 5.07605V3.5H14V5.07605C12.3332 5.33238 10.8994 6.21866 10 7.45869V5.58594ZM7.99609 20.0002H4V6.41437L6 4.41436L8 6.41436L7.99609 20.0002Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.5 17V22H16.5V17H13.5Z"}}]};

const Mosque1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mosque-1-filled',
    ref,
    icon: element,
  },
));

Mosque1FilledIcon.displayName = 'Mosque1FilledIcon';

export default Mosque1FilledIcon;
